import { render, staticRenderFns } from "./BloodSugar.vue?vue&type=template&id=234fad08&scoped=true&"
import script from "./BloodSugar.vue?vue&type=script&lang=js&"
export * from "./BloodSugar.vue?vue&type=script&lang=js&"
import style0 from "./BloodSugar.vue?vue&type=style&index=0&id=234fad08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fad08",
  null
  
)

export default component.exports